const fadeInSection = () => {
    let sections = gsap.utils.toArray('section');
    if (!sections.length) return;
    
    sections.forEach((item) => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top 90%",
                end: "bottom 70%",
            }
        });
        tl.to(item, {
            opacity: 1,
            duration: 1,
        });
    });
}

export default fadeInSection;